export default __webpack_public_path__ + "static/media/dripicons-v2.de54f4eb.svg";